import { useField } from "@unform/core";
import { useEffect, useRef } from "react";
import { Controller, useFormContext, useFormState } from "react-hook-form";
import InputSelectComponent, { components } from "react-select";

import Alert from "../../Components/Alert";
import Prefix from "../../Components/Prefix";
import * as S from "./styles";

import { useTheme } from "styled-components";

const Core = ({
  ref,
  name,
  options,
  label,
  placeholder,
  alertType,
  alertMessage,
  size = "md",
  required,
  disabled,
  prefix,
  variant = "dark",
  ...rest
}) => {
  const theme = useTheme();
  const { fieldName, registerField } = useField(name);
  const inputRef = useRef(null);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: ref ? ref.current : inputRef.current,
      path: "state.value",
      getValue: (ref) => {
        if (rest.isMulti) {
          if (!ref.state.selectValue) {
            return [];
          }
          return ref.state.selectValue.map((option) => option.value);
        } else {
          if (!ref.state.selectValue) {
            return "";
          }
          return ref.state.selectValue[0]
            ? ref.state.selectValue[0].value
            : rest.value;
        }
      },
      clearValue: (ref) => {
        ref.clearValue();
      },
    });
    //eslint-disable-next-line
  }, [fieldName, registerField, rest.isMulti]);

  const methods = useFormContext();
  const { setFocus, control } = methods ? methods : {};

  const { errors } =
    methods && control
      ? useFormState({
          control,
        })
      : {};

  useEffect(() => {
    if (errors && errors[fieldName]) {
      setFocus(fieldName);
    }
  }, [errors]);

  const Control = ({ children, ...props }) => (
    <components.Control {...props}>
      {prefix && <Prefix size={size} {...prefix} />}
      {children}
    </components.Control>
  );

  const SelectComponent = (onChange, value) => {
    return (
      <InputSelectComponent
        {...rest}
        ref={ref || inputRef}
        classNamePrefix="react-select"
        name={name}
        options={options}
        styles={S.CustomStyles(theme, size, alertType, disabled)}
        placeholder={placeholder}
        components={{ Control }}
        required={required}
        isDisabled={disabled}
        value={
          rest?.value ||
          options.find((option) => option.value === value) ||
          value ||
          options.find((option) => option.value === rest.defaultValue) ||
          null
        }
        onChange={(e) => {
          rest?.onChange ? rest.onChange(e) : onChange(e?.value);
        }}
      />
    );
  };

  return (
    <S.Wrapper
      style={{
        gridArea: rest?.gridArea,
      }}
      variant={variant}
      {...rest}
    >
      <S.Label required={required} htmlFor={name}>
        {label}
      </S.Label>
      {control ? (
        <Controller
          control={control}
          name={name}
          render={({ field: { onChange, value } }) => {
            return SelectComponent(onChange, value);
          }}
        />
      ) : (
        SelectComponent(null, null)
      )}
      {(alertType && alertMessage) ||
        (errors && errors[fieldName] && (
          <Alert
            type={alertType}
            message={alertMessage || errors[fieldName]?.message}
            size={size}
          />
        ))}
    </S.Wrapper>
  );
};

export default Core;
